import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Hourglass = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 26H25.925C25.575 23.512 23.937 21.75 22.475 20.175C21.15 18.737 20 17.5 20 16C20 14.5 21.15 13.262 22.488 11.825C23.938 10.25 25.575 8.487 25.926 6H27.001C27.551 6 28.001 5.55 28.001 5C28.001 4.45 27.551 4 27.001 4H5.001C4.451 4 4.001 4.45 4.001 5C4.001 5.55 4.451 6 5.001 6H6.076C6.426 8.487 8.063 10.25 9.526 11.825C10.851 13.263 12.001 14.5 12.001 16C12.001 17.5 10.851 18.738 9.513 20.175C8.063 21.75 6.425 23.512 6.075 26H5C4.45 26 4 26.45 4 27C4 27.55 4.45 28 5 28H27C27.55 28 28 27.55 28 27C28 26.45 27.55 26 27 26V26ZM8.1 26C8.45 24.262 9.688 22.937 10.988 21.538C12.476 19.938 14 18.288 14 16C14 13.712 12.463 12.062 10.988 10.463C9.688 9.063 8.451 7.738 8.101 6H23.901C23.551 7.737 22.314 9.063 21.014 10.463C19.526 12.063 18.002 13.713 18.002 16C18.002 18.287 19.54 19.938 21.014 21.538C22.314 22.938 23.552 24.263 23.901 26H8.101H8.1Z" />
	</svg>
);

export default Hourglass;
